import React, { useEffect, useState } from "react";

interface TableViewerWithPaginationProps {
  data: any[][]; // CSV/Excelパース済みの行データ
  pageSize?: number; // 1ページあたりの表示行数
}

const DEFAULT_PAGE_SIZE = 200;

const TableViewerWithPagination: React.FC<TableViewerWithPaginationProps> = ({
  data,
  pageSize = DEFAULT_PAGE_SIZE,
}) => {
  const [pageNumber, setPageNumber] = useState<number>(1);

  const numPages = Math.max(1, Math.ceil(data.length / pageSize));

  // データが切り替わったら1ページ目に戻す
  useEffect(() => {
    setPageNumber(1);
  }, [data]);

  const goToPreviousPage = () => {
    setPageNumber((prevPage) => Math.max(prevPage - 1, 1));
  };

  const goToNextPage = () => {
    setPageNumber((prevPage) => Math.min(prevPage + 1, numPages));
  };

  const startIndex = (pageNumber - 1) * pageSize;
  const pageRows = data.slice(startIndex, startIndex + pageSize);

  return (
    <div>
      {numPages > 1 && (
        <div style={{ marginBottom: "10px" }}>
          <button onClick={goToPreviousPage} disabled={pageNumber <= 1}>
            Previous
          </button>
          <span style={{ margin: "0 10px" }}>
            Page {pageNumber} of {numPages}
          </span>
          <button onClick={goToNextPage} disabled={pageNumber >= numPages}>
            Next
          </button>
        </div>
      )}
      <table className="data-table">
        <tbody>
          {pageRows.map((row, rowIndex) => (
            <tr key={startIndex + rowIndex}>
              {row.map((col, colIndex) => (
                <td key={colIndex}>{col || "　"}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableViewerWithPagination;
